import {PageView} from "./PageView.js";
import {InviteLayout} from "../components/layout/InviteLayout.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {getEmail, getUser} from "../store.js";
import {findInviterList} from "../../../apiCall/signup/index.js";
import {InviterList} from "../components/InviterList.js";

export class CompanyInviteUserView extends PageView {

    renderLayout() {
        const {mainText = '', subText = '', mainLabel = "", subLabel = ""} = this.$props;
        this.$props.InviteLayout = new InviteLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            nextButton: {
                mainLabel ,
                subLabel,
                text: this.getNextButtonText(),
                nextPageFunc: () => {
                    SignUpViewChanger.loadCompanyInfoInputView();
                }
            },
            nextLink : {
                text : i18next.t(login.newWorkspace),
                nextPageFunc: () => {
                    SignUpViewChanger.loadCompanyInfoInputView();
                }
            }
        });
    }

    async renderComponents() {
        if(!this.$props.InviteLayout) {
            return;
        }
        const {
            inviterList = []
        } = this.$props;
        if(inviterList.length !== 0) {
            this.renderCompanyInviteComponent(inviterList);
            return;
        }

        const curInviterList = await getUser().getInviterList();
        if(curInviterList.length !== 0) {
            this.renderCompanyInviteComponent(curInviterList);
            return;
        }

        SignUpViewChanger.loadCompanyInfoInputView();

    }


    renderCompanyInviteComponent(inviterList = []) {
        new Header(this.$props.InviteLayout.getHeaderLayer(), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });
        new InviterList(this.$props.InviteLayout.getInviteUlLayer(), {
            inviterList,
            moveCompanyInfoPage: () => {
                SignUpViewChanger.loadCompanyInfoView(true);
            }
        })
    }

    getSectionId() {
        return `companyInviteSection`
    }

    getNextButtonText() {
        return i18next.t(login.createCompany);
    }
}